import { render, staticRenderFns } from "./ElementCommentsTableColumn.vue?vue&type=template&id=31efb156&scoped=true"
import script from "./ElementCommentsTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCommentsTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementCommentsTableColumn.vue?vue&type=style&index=0&id=31efb156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efb156",
  null
  
)

export default component.exports